import { render, staticRenderFns } from "./AdminOrderList.vue?vue&type=template&id=7aa4db76&"
import script from "./AdminOrderList.vue?vue&type=script&lang=js&"
export * from "./AdminOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports